export const downloadSheet = async (url, exportFileName) => {
  const data = await fetch(url, {
    headers: {
      Authorization: localStorage.getItem('feathers-jwt'),
    },
  });
  const blob = await data.blob();
  const downloadUrl = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = downloadUrl;
  a.download = exportFileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(downloadUrl);
};
